import React from "react";

const Mad = ({ width, height, size = 24, fill = "currentColor", ...props }) => (
  <svg
    {...props}
    width={width || size}
    height={height || size}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0Z"
      fill="#E92B2B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0009 6.17578L13.3084 10.1999H17.5397L14.1166 12.687L15.4241 16.7111L12.0009 14.2241L8.5778 16.7111L9.88532 12.687L6.46216 10.1999H10.6934L12.0009 6.17578ZM10.4706 10.8856H8.57255L10.1081 12.0012L10.4706 10.8856ZM10.6914 12.425L11.1916 10.8856H12.8103L13.3104 12.425L12.0009 13.3765L10.6914 12.425ZM10.4686 13.1108L9.88211 14.9159L11.4176 13.8003L10.4686 13.1108ZM12.5842 13.8003L14.1198 14.9159L13.5332 13.1108L12.5842 13.8003ZM13.8937 12.0012L15.4293 10.8856H13.5312L13.8937 12.0012ZM12.5875 10.1999H11.4144L12.0009 8.39482L12.5875 10.1999Z"
      fill="#32AB45"
    />
  </svg>
);

export default Mad;
